import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPlus, FaMinus } from 'react-icons/fa';

const FAQS = [
  {
    q: 'Is JobxBharat free for job seekers?',
    a: 'Yes — searching for jobs, building a resume, and applying is 100% free for job seekers.',
  },
  {
    q: 'Which job categories are available?',
    a: 'White-collar (IT, Finance, HR, Sales etc.), blue-collar (Delivery, Electrician, Security etc.), and Government jobs (Railway, SSC, Banking etc.).',
  },
  {
    q: 'How is this different from Naukri or Apna?',
    a: 'JobxBharat is the only platform that combines white-collar jobs, blue-collar workforce, government notifications, and placement ERP for colleges in one place.',
  },
  {
    q: 'How does the AI matching work?',
    a: 'We analyse your skills, experience, location, and preferences to rank jobs by fit — not by date posted. The more you use the platform the better it gets.',
  },
  {
    q: 'I represent a college. How do I get the placement ERP?',
    a: "Use the 'Book a demo' button in the Colleges section or email us. Onboarding typically takes one week.",
  },
  {
    q: 'Which languages does the platform support?',
    a: 'English and Hindi are available now. Hinglish, Gujarati, Punjabi, and Odia support is coming soon.',
  },
];

function FAQItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-gray-100 last:border-0">
      <button
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center justify-between py-5 text-left
                   font-display font-bold text-ink-900 hover:text-brand-purple
                   transition-colors text-base focus:outline-none"
      >
        {q}
        <span className="shrink-0 ml-4 text-brand-purple">
          {open ? <FaMinus /> : <FaPlus />}
        </span>
      </button>
      <AnimatePresence>
        {open && (
          <motion.p
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="text-ink-500 text-sm leading-relaxed pb-5 overflow-hidden"
          >
            {a}
          </motion.p>
        )}
      </AnimatePresence>
    </div>
  );
}

export default function FAQ() {
  return (
    <section className="py-14 md:py-24 px-4 sm:px-6 bg-white border-t border-gray-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <span className="text-xs font-black tracking-widest uppercase text-brand-purple">FAQ</span>
          <h2 className="font-display font-black text-3xl md:text-4xl text-ink-900 mt-3">
            Common questions
          </h2>
        </div>
        <div className="bg-paper rounded-3xl border border-gray-100 p-6 md:p-10">
          {FAQS.map(item => <FAQItem key={item.q} {...item} />)}
        </div>
      </div>
    </section>
  );
}
